import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  root: {},
  container: {
    height:170,
  },
  card: {
    width: '80%',
    margin:"0 auto",
    height: '100%',
    borderRadius: 3,
    padding: 8,
    display: 'flex',
    boxShadow: '6px 8px 6px 5px rgb(0 0 0 / 18%)',
    flexDirection:'column',
    justifyContent:'center',
    transition: 'background 0.3s ease',
    background:
    "linear-gradient(38deg, rgba(10,110,112,1) 0%, rgba(22,198,227,0.8436624649859944) 65%)",
    '&:hover': {
      background:
      "linear-gradient(38deg, rgba(203,93,9,1) 0%, rgba(242,142,10,0.8436624649859944) 65%) !important",
        },
  },
  nameLabel: {
    '& .MuiTypography-root': {
      paddingBlockEnd: 8,
      fontWeight: 800,
      color: '#fff',
      fontSize: 15,
      textTransform: 'uppercase',
    },
  },
  tableheader:{
    '& .MuiTableCell-head': {
    fontWeight: "bold"
    },
  },
  triptable:{
    width:"100% !important"
  },  
  spaceme:{
 margin:"10px 0 !important"
  },
    rightimage:{
  backgroundImage: "url('/assets/images/login_page_image_6.jpg')",
  backgroundSize: "cover",       // fills without distorting
  backgroundPosition: "center",  // center the focus
  backgroundRepeat: "no-repeat",
  height: "100vh",               // full viewport height
  width: "100%",        
  }
}))

export default useStyles
